import NOB from '../../constants/language-strings';
export const getHours = (minutes) => {
    if (!minutes && minutes !== 0)
        return `0${NOB.ORDERED_PRODUCTS.HOURS}`;
    return `${Math.floor(minutes / 60)}${NOB.ORDERED_PRODUCTS.HOURS}`;
};
export const getMinutes = (totalMinutes) => {
    if (!totalMinutes && totalMinutes !== 0)
        return `0${NOB.ORDERED_PRODUCTS.MINUTES}`;
    return `${totalMinutes % 60}${NOB.ORDERED_PRODUCTS.MINUTES}`;
};
